import React from 'react'

import { valueOrEmptyString } from 'helpers/strings'
import { EDUCATION_OPTIONS } from 'constants/profile'

import Label from './Label'
import DefaultInput from './Input'
import Select from './Select'

const Input = props => <DefaultInput classNames={{ input: 'border-white' }} {...props} />

const InputEducation = ({ autoFocus, onChange, userData }) => {
  return (
    <div className="text-white">
      <Label>Education</Label>
      <div className="uppercase font-medium font-ownersWide mb-1">School / Institution</div>
      <Input
        key={autoFocus}
        autoFocus={autoFocus}
        name="education"
        value={valueOrEmptyString(userData.profile.education)}
        type="text"
        placeholder="School / Institution"
        onChange={onChange}
      />
      <br />
      <div className="uppercase font-medium font-ownersWide mb-1">Degree / Diploma</div>
      <Select
        name="educationLevel"
        defaultLabel="Degree / Diploma"
        options={EDUCATION_OPTIONS}
        onChange={onChange}
        value={valueOrEmptyString(userData.profile.educationLevel)}
      />
    </div>
  )
}

export default InputEducation
